// Copy for the home view: hero, metadata strip, and the "01 · Position" essay.

const HERO = {
	eyebrow: "San Diego, California",
	lede: "Machine learning, generative AI, and now agentic systems, architected and shipped into production for enterprises that cannot afford them to misbehave. Nineteen years of engineering underneath.",
	portrait: "/portrait.jpg",
	portraitAlt: "Anjanava Biswas",
};

const META_STRIP = [
	{
		label: "Now",
		value: "Principal Solutions Architect, Applied AI",
		sub: "ServiceNow, Forward Deployed Engineering",
	},
	{
		label: "Previously",
		value: "AWS · Petco · IBM · Oracle",
		sub: "Specialist SA, domain architecture, ERP engineering",
	},
	{
		label: "Written",
		value: "Books and Research Papers",
		sub: "Packt Publishing · arXiv · IEEE · INFORMS",
	},
	{
		label: "Elected",
		value: "IEEE Senior Member · IET & BCS Fellow",
		sub: "OWASP LLM Top 10 contributor · SIA AI Advisory Board",
	},
];

const POSITION = {
	pull: "I work on the part of applied AI that is unglamorous and decisive: what the system does when it is wrong, who is accountable, how it holds up at enterprise scale.",
	paragraphs: [
		"Five years at AWS as a specialist architect on generative AI and document intelligence: shipping RAG and agentic-RAG pipelines into production, building computer vision and NLP systems for healthcare, financial services and the public sector, and acting as the connective tissue between those customers and the teams building Textract, Q Business and Bedrock. Before that, machine learning for computer vision at Petco, and further back a decade of enterprise and platform architecture that taught me what production actually costs.",
		"Today the same problem has moved up a layer. Agents plan, call tools, and act on behalf of employees and customers. I design the architecture for evaluating and constraining them.",
	],
};

export { HERO, META_STRIP, POSITION };
